
import React from 'react';
import { Article } from '../types';

// This is a placeholder as the functionality is now integrated into the panels.
// This component renders the visual arrow buttons.
interface TransferControlsProps {
    onAdd: (articles: Article[]) => void;
    onRemove: (articles: Article[]) => void;
}


const TransferControls: React.FC<Partial<TransferControlsProps>> = () => {
  return (
    <>
      <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 shadow-inner">
        <i className="fas fa-arrow-right text-xl"></i>
      </div>
       <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 shadow-inner">
        <i className="fas fa-arrow-left text-xl"></i>
      </div>
    </>
  );
};

export default TransferControls;